// extracted by mini-css-extract-plugin
export default {"Input":"Search_Input__I+X-3","Button":"Search_Button__Oi+V2"};